import { memo, useMemo } from "react";

import Timestamp from "components/Timestamp";
import { formatDate } from "utils/date";
import { unixTimestampToMs } from "utils/time";

import { type RenderResourceRowCellProps } from ".";
import IacManagementEmptyCellValue from "../../components/CellEmptyValue";
import IacManagementResourceCell from "../components/ResourceCell";
import useCellCopyAction from "../useCellCopyAction";
import { ResourcesSuggestions } from "../../useIacManagementFilters/constants";

const IacManagementTableResourceRowCellUpdatedAt = memo((props: RenderResourceRowCellProps) => {
  const { row } = props;
  const timestamp = row.updater?.updatedAt;

  const formattedTimestamp = formatDate({
    date: unixTimestampToMs(timestamp || 0),
  });

  const copyAction = useCellCopyAction(ResourcesSuggestions.UpdatedAt, formattedTimestamp);
  const actions = useMemo(() => (timestamp ? [copyAction] : []), [timestamp, copyAction]);

  return (
    <IacManagementResourceCell {...props} actions={actions}>
      {(timestamp && <Timestamp timestamp={timestamp} />) || <IacManagementEmptyCellValue />}
    </IacManagementResourceCell>
  );
});

IacManagementTableResourceRowCellUpdatedAt.displayName =
  "IacManagementTableResourceRowCellUpdatedAt";

export default IacManagementTableResourceRowCellUpdatedAt;
